import {ReactNode} from 'react';
import {ScenarioNodeTag} from '@types';
import {useTheme} from './theme/useTheme';

type ScenarioEndnessTagsProps = {
    tags?: ScenarioNodeTag[] | null;
    className?: string;
    empty?: ReactNode;
};

const getEndnessTagClassName = (tag: ScenarioNodeTag, isDark: boolean) => {
    const base = 'rounded border px-2 py-0.5 text-xs';
    const emphasis = tag.primary ? 'font-bold' : 'font-medium';

    if (tag.effect === 'end') {
        return `${base} ${emphasis} ${isDark ? 'border-emerald-700 bg-emerald-950 text-emerald-200' : 'border-emerald-200 bg-emerald-50 text-emerald-800'}`;
    }

    if (tag.effect === 'block') {
        return `${base} ${emphasis} ${isDark ? 'border-red-700 bg-red-950 text-red-200' : 'border-red-200 bg-red-50 text-red-800'}`;
    }

    return `${base} ${emphasis} ${isDark ? 'border-neutral-700 bg-neutral-900 text-neutral-200' : 'border-neutral-200 bg-neutral-50 text-neutral-700'}`;
};

export const ScenarioEndnessTags = ({
    tags,
    className = '',
    empty = null,
}: ScenarioEndnessTagsProps) => {
    const isDark = useTheme() === 'dark';
    const endnessTags = (tags ?? []).filter(tag => tag.type === 'endness');

    if (endnessTags.length === 0) {
        return <>{empty}</>;
    }

    return (
        <span className={`inline-flex flex-wrap gap-1.5 ${className}`}>
            {endnessTags.map(tag => (
                <span
                    key={`${tag.type}:${tag.code}`}
                    className={getEndnessTagClassName(tag, isDark)}
                    title={tag.effect ?? undefined}>
                    {tag.code}
                </span>
            ))}
        </span>
    );
};
